export default {
    computed: {
        isSmartphone() {
            return this.$device.mobile && !this.$device.isTablet;
        },
    }
};